import { IconButton as RadixIconButton } from "@radix-ui/themes";
import { styled } from "@stitches/react";

export const IconButton = styled(RadixIconButton, {
  cursor: "pointer",
});
